import { FIELD_TYPES } from "constants/template-field-type";
import TitleConfig from "segments/desktop/core-components/title/fields-config";
import ParagraphConfig from "segments/desktop/core-components/paragraph/fields-config";
import ThemeConfig from "segments/core-configs/theme-config";
import AssetFieldsConfig from "components/core/asset/fields-config";

const { titleColor, ...restOfTitleConfig } = TitleConfig;
const { bodyColor, ...restOfParagraphConfig } = ParagraphConfig;

export default {
  type: FIELD_TYPES.NESTED,
  label: "Products Horizontal Timer",
  fields: {
    ...ThemeConfig,
    tabs: {
      type: FIELD_TYPES.MULTIPLE_NESTED,
      label: "Tabs",
      nestedConfig: {
        type: FIELD_TYPES.NESTED,
        fields: {
          productType: { type: FIELD_TYPES.PRODUCTS, label: "Product type" },
          title: {
            type: FIELD_TYPES.NESTED,
            label: "Tab title",
            fields: {
              productImage: { type: FIELD_TYPES.GALLERY, label: "Product logo image" },
              ...restOfTitleConfig,
              ...restOfParagraphConfig
            }
          },
          asset: {
            type: FIELD_TYPES.NESTED,
            label: "Asset",
            fields: AssetFieldsConfig
          }
        }
      }
    },
    progressbarColor: { type: FIELD_TYPES.COLOR_PICKER, label: "Progress Bar Color" }
  }
};
